import { useContext, useEffect, useState } from 'react';

import { DataContext } from 'providers/data';
import { AdditionalServices } from 'core/productsTemplate';

import { ParamsProductServiceAdd } from 'utils/typeServices';
import { ParseQuotation } from 'utils/getIconIndividualServices';

import { Box, Typography, Button, Collapse } from '@mui/material';

import { ReactComponent as IcTakeArrowQuestions } from 'assets/icons/take-arrow-questions-icon.svg';

import { ButtonCustom } from '../PackagesServices/styles';

type ParamsListServices = {
    ListServices: Array<ParamsProductServiceAdd>;
    cdQuotation: number;
    listServicesAddTemplate: Array<ParamsProducTemplate>;
}

type ParamsProducTemplate = {
    NM_PRODUTO: string;
    CD_PRODUTO: number;
    NM_TITULO: string;
    DS_PRODUTO: Array<{
        DS_COBERTURA: Array<string>;
    }>;
}

type ParamsCard = {
    Product: ParamsProductServiceAdd;
    cdQuotation: number;
    handleShowDetails: (CD_PRODUTO: number) => void;
    isActiveDetails: boolean;
}

const Card = ({ Product, cdQuotation, handleShowDetails, isActiveDetails }: ParamsCard) => {
    const [isActive, setIsActive] = useState(false);
    const [addToCart, setAddToCart] = useState(false);
    const [isDetailsProduct, setIsDetailsProduct] = useState(false);
    const { selectedCar, dataProductCartAddServices, dataListActiveProducts, handleProductCartAddServices } = useContext(DataContext);

    const handleService = () => {
        if (selectedCar) {
            handleProductCartAddServices({
                bodyBase: {
                    cD_COTACAO: cdQuotation,
                    cD_PEDIDO: selectedCar.CD_PEDIDO,
                    customerId: selectedCar.CD_PESSOA,
                },
                body: {
                    cD_COTACAO_ITEM: Product.CD_COTACAO_ITEM,
                    cD_PRODUTO: Product.CD_PRODUTO,
                    nM_PRODUTO: Product.NM_PRODUTO,
                    nR_TIPO_PRODUTO: Product.NR_TIPO_PRODUTO,
                    nR_PORCENTAGEM_INDENIZACAO: Product.NR_PORCENTAGEM_INDENIZACAO,
                    vL_TOTAL: `R$ ${Product.VL_TOTAL?.split(' ')[1]}`
                },
                addProduct: !addToCart,
            });
        }
    }

    useEffect(() => {
        if (dataProductCartAddServices?.productAdd) {
            if (dataProductCartAddServices.productAdd?.findIndex(({ cD_PRODUTO }) => cD_PRODUTO === Product.CD_PRODUTO) > -1) {
                setAddToCart(true);
            } else {
                setAddToCart(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataProductCartAddServices]);

    useEffect(() => {
        if (dataListActiveProducts) {
            if (dataListActiveProducts.find(({ CD_PRODUTO }) => CD_PRODUTO === Product.CD_PRODUTO)) {
                setIsActive(true);
            } else {
                setIsActive(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataListActiveProducts]);

    useEffect(() => {
        if (AdditionalServices?.find(({ CD_PRODUTO }) => CD_PRODUTO === Product.CD_PRODUTO)) {
            setIsDetailsProduct(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cdQuotation]);

    return (
        <Box sx={{ transition: 'ease-in-out 200ms', paddingBottom: '.3rem' }} borderBottom={isActiveDetails ? '1px solid #17A7E0' : 'none'}>
            <Box sx={{
                display: 'grid',
                gridTemplateRows: '1.9rem 1.5rem 2.5rem 1.6rem',
                textAlign: 'center',
                padding: '.56rem 0 .5rem',
                borderRadius: '.38619rem',
                border: `1px solid ${isActive ? '#97C93D' : isActiveDetails ? '#0AA8E3' : '#0C1C33'}`,
                cursor: isDetailsProduct ? 'pointer' : 'default',
                boxShadow: isActiveDetails ? '0 0 0 1.5px #0AA8E3' : 'none',
                transition: 'ease-in-out 200ms'
            }}
                onClick={() => isDetailsProduct && handleShowDetails(Product.CD_PRODUTO)}
            >
                <Box sx={{
                    paddingBottom: '.3rem',
                    'svg': {
                        height: '1.56rem',
                        'path': { fill: ([2580, 2581].indexOf(Product.CD_PRODUTO) < 0) ? '#0C1C33' : '' }
                    }
                }}>
                    {Product.CD_PRODUTO && ParseQuotation(Product.CD_PRODUTO)}
                </Box>
                <Typography sx={{ fontSize: '.75rem', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600 }}>
                    {Product.NM_PRODUTO}
                </Typography>
                <Box>
                    <Typography sx={{ fontSize: '.5625rem', fontWeight: 300, padding: '.4rem 0 .2rem' }}>
                        Mensalidade
                    </Typography>
                    <Typography sx={{ fontSize: '1.125rem', fontWeight: 700 }}>
                        {Product.VL_TOTAL}
                    </Typography>
                </Box>

                <Button
                    variant="text"
                    endIcon={<IcTakeArrowQuestions />}
                    disabled={isDetailsProduct ? false : true}
                    sx={{ '&:hover': { backgroundColor: 'transparent' }, height: '1rem', marginTop: '.4rem', padding: '0', fontSize: '.75rem', fontWeight: 600, color: 'primary.light', 'svg': { width: '.8rem', margin: '0 0 .3rem -.1rem', transform: isActiveDetails ? 'rotate(0deg)' : 'rotate(180deg)', filter: isDetailsProduct ? 'grayscale(0)' : 'grayscale(1)', transition: '300ms' } }}
                >
                    SAIBA MAIS
                </Button>
            </Box>

            <ButtonCustom className={isActive ? 'contratado' : 'individual'} variant='contained' handlebutton={addToCart ? 'remove' : 'add'} onClick={() => !isActive && handleService()}>
                {isActive ? 'CONTRATADO' : addToCart ? 'REMOVER' : 'ADICIONAR'}
            </ButtonCustom>
        </Box >
    )
}

const IndividualServices = ({ ListServices, cdQuotation, listServicesAddTemplate }: ParamsListServices) => {
    const [openDetails, setOpenDetails] = useState(false);
    const [indexProductSelected, setIndexProductSelected] = useState<number>();
    const [productSelected, setProductSelected] = useState<ParamsProducTemplate | null>();

    const handleSelectedProduct = (e: number, isOpen: boolean) => {
        if (isOpen) {
            setOpenDetails(false);
        }

        const index = ListServices.findIndex(({ CD_PRODUTO }) => CD_PRODUTO === e);
        const selected = AdditionalServices.find(({ CD_PRODUTO }) => CD_PRODUTO === e);

        if ((index >= 0) && ((index !== indexProductSelected) || (!isOpen && (index === indexProductSelected)))) {
            setIndexProductSelected(index);

            if (index !== -1 && selected) {
                setProductSelected(selected);

                setTimeout(() => {
                    setOpenDetails(true);
                }, 300);
            }
        }
    }

    return (
        <Box>
            <Typography sx={{ fontSize: '1.5625rem', 'span': { color: 'primary.light' }, marginBottom: '.7rem' }}>
                Adicione os <strong>serviços abaixo e fique <span>mais protegido:</span></strong>
            </Typography>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', columnGap: { xs: '2%', md: '1%' } }}>
                {ListServices.map((value, index) =>
                    <>
                        <Box sx={{
                            width: {
                                xs: '49%',
                                md: '24%'
                            },
                            padding: {
                                xs: '0 0 1.12rem 0',
                                md: '.3rem 0 .2rem 0'
                            }
                        }}>
                            <Card Product={value} cdQuotation={cdQuotation} key={index} isActiveDetails={(index === indexProductSelected) && openDetails} handleShowDetails={(e) => handleSelectedProduct(e, openDetails)} />
                        </Box >

                        <Collapse in={openDetails} sx={{
                            width: '100%',
                            paddingBottom: openDetails ? '1.2rem' : '',
                            display: {
                                xs: ((((index + 1) % 2) === 0) || ((index + 1) === ListServices.length)) && (Math.trunc(((index) / 2)) === Math.trunc(((indexProductSelected || 0) / 2))) ? 'block' : 'none',
                                md: ((((index + 1) % 4) === 0) || ((index + 1) === ListServices.length)) && (Math.trunc(((index) / 4)) === Math.trunc(((indexProductSelected || 0) / 4))) ? 'block' : 'none'
                            }
                        }}>
                            <Box sx={{ padding: '.82rem 1.14rem .8rem', transition: '300ms', width: '100%', position: 'relative', borderRadius: '0rem 0rem 0.625rem 0.625rem', border: '1px solid #0AA8E3' }}>
                                <Typography sx={{ fontSize: '.875rem' }} dangerouslySetInnerHTML={{ __html: productSelected?.NM_TITULO || '' }} />
                                <Typography sx={{ fontSize: '.875rem', color: 'primary.light', paddingTop: '.45rem' }}><b>Importante:</b></Typography>
                                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, paddingTop: '1rem', gap: '.5rem', justifyContent: 'space-between' }}>
                                    {productSelected?.DS_PRODUTO.map(({ DS_COBERTURA }, index) =>
                                        <Box key={index} sx={{
                                            flex: '1',
                                            'ul': {
                                                listStyleType: 'initial',
                                                paddingLeft: '1.5rem'
                                            },
                                            'li': {
                                                fontSize: '.875rem',
                                                paddingBottom: '.2rem',
                                                listStyleType: 'initial'
                                            },
                                            'table, td, th': {
                                                border: '1px solid black'
                                            },
                                            'table': {
                                                width: { xs: '40rem', md: '200%' },
                                                textAlign: 'center',
                                                borderCollapse: 'collapse',
                                            },
                                            'th': {
                                                width: '130px',
                                                fontWeight: 700,
                                                backgroundColor: '#00B0F0',
                                                padding: '.3rem 0 .1rem'
                                            },
                                            'td': {
                                                backgroundColor: '#315496',
                                                color: 'white',
                                                padding: '.3rem 0 .1rem'
                                            },
                                            '#table': {
                                                maxWidth: { xs: '390px', md: '200%' },
                                                overflow: { xs: 'auto', md: 'inherit' },
                                                '::-webkit-scrollbar': {
                                                    width: '5px',
                                                    height: '8px'
                                                },
                                                '::-webkit-scrollbar-thumb': {
                                                    borderRadius: '10px',
                                                    backgroundColor: 'rgb(0, 176, 240, .5)',
                                                }
                                            }
                                        }}>
                                            {DS_COBERTURA.map((value, index) =>
                                                <Typography
                                                    key={index}
                                                    sx={{ fontSize: '.875rem', paddingBottom: '.3rem' }} dangerouslySetInnerHTML={{ __html: value }} />
                                            )}
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Collapse >

                    </>
                )}
            </Box>
        </Box >
    );
}

export default IndividualServices;